import React from 'react';

import { Modal } from '@wds/modal';
import { Box } from '@wds/box';

import PropTypes from 'prop-types';

import MFA from '../Authentication/MFA';

const MFAEnrollmentModal = (props) => {
	const {
		open,
		context,
		setContext,
		handleClose,
		onRecoveryEmailVerified,
	} = props;

	return (
		<Box id='sma-mfa-enrollment-modal'>
			<Modal
				show={open}
				data-testid='mfa-enrollment-modal'
				onClose={handleClose}
				dismissible
			>
				<Modal.Body>
					<MFA
						context={context}
						setContext={setContext}
						isModal
						handleClose={handleClose}
						onRecoveryEmailVerified={onRecoveryEmailVerified}
					/>
				</Modal.Body>
			</Modal>
		</Box>
	);
};

MFAEnrollmentModal.propTypes = {
	open: PropTypes.bool.isRequired,
	context: PropTypes.object.isRequired,
	setContext: PropTypes.func.isRequired,
	handleClose: PropTypes.func.isRequired,
	onRecoveryEmailVerified: PropTypes.func,
};

MFAEnrollmentModal.defaultProps = {
	onRecoveryEmailVerified: null,
};

export default MFAEnrollmentModal;
